import React, { useState, useContext } from 'react';
import CustomInput from '../../components/shared/custom-input';
import Button from '../../components/shared/custom-btn';
import { createAccounts } from '../../services/auth-service';
import { useNavigate } from 'react-router-dom';
import { AccountsContext } from '../../components/context/account-context';

const CreateAccountModal = ({ setShowCreateModal, token, onSuccess }) => {
    const { setAccountId } = useContext(AccountsContext);
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        name: '',
        category: '',
        website: ''
    });
    const [errors, setErrors] = useState({});
    const [successMessage, setSuccessMessage] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
        setErrors((prev) => ({ ...prev, [name]: '' }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const newErrors = {};
        if (!formData.name) newErrors.name = 'Account name is required';
        if (!formData.category) newErrors.category = 'Category is required';
        setErrors(newErrors);

        if (Object.keys(newErrors).length > 0) return;

        setIsSubmitting(true);
        try {
            const payload = {
                name: formData.name,
                category: formData.category,
                website: formData.website || 'www.example.com'
            };
            const response = await createAccounts(payload, token);

            console.log('Create account response:', response); // Debug

            if (response.success) {
                setSuccessMessage('Account created successfully!');
                const newAccountId = response.data.data.accountId;
                setAccountId(newAccountId); // Update context
                localStorage.setItem('accountId', newAccountId); // Store as plain string
                setTimeout(() => {
                    setShowCreateModal(false);
                    navigate('/dashboard');
                    if (onSuccess) onSuccess();
                }, 2000);
            } else {
                setErrors({
                    apiError: response.data.message || 'Failed to create  account.'
                });
            }
        } catch (error) {
            console.error('Error creating  account:', error);
            setErrors({
                apiError: error.message || 'An unexpected error occurred.'
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-30 h-full flex items-center justify-center z-50">
            <div className="!px-4 gap-6 max-w-md w-full rounded-lg !py-0">
                <div className="flex bg-white w-full flex-col items-center justify-center py-7 lg:px-6 px-4 rounded-lg">
                    <h2 className="text-2xl text-center font-bold text-gray-800 mb-6">Create Business Account</h2>
                    {successMessage && (
                        <div
                            className="mb-4 p-3 bg-green-100 text-green-700 text-sm rounded-lg text-center"
                            role="alert"
                        >
                            {successMessage}
                        </div>
                    )}
                    {errors.apiError && (
                        <div
                            className="mb-4 p-3 bg-red-100 text-red-700 text-sm rounded-lg text-center"
                            role="alert"
                        >
                            {errors.apiError}
                        </div>
                    )}
                    <form onSubmit={handleSubmit} className="space-y-3 w-full">
                        <CustomInput
                            label="Business Name"
                            name="name"
                            type="text"
                            value={formData.name}
                            onChange={handleChange}
                            inputStyle={`p-2 w-full bg-white border !text-sm rounded-lg ${errors.name ? 'border-red-500' : 'border-border'}`}
                            placeholder="e.g., YoGPS Inc."
                            error={errors.name}
                            // maxLength={15}
                        />
                        <CustomInput
                            label="Category"
                            name="category"
                            type="text"
                            value={formData.category}
                            onChange={handleChange}
                            inputStyle={`p-2 w-full bg-white border !text-sm rounded-lg ${errors.category ? 'border-red-500' : 'border-border'}`}
                            placeholder="e.g., plumbing"
                            error={errors.category}
                        />
                        <CustomInput
                            label="Website (Optional)"
                            name="website"
                            type="text"
                            value={formData.website}
                            onChange={handleChange}
                            inputStyle={`p-2 w-full bg-white border !text-sm rounded-lg ${errors.website ? 'border-red-500' : 'border-border'}`}
                            placeholder="e.g., www.yogps.com"
                            error={errors.website}
                        />
                        <Button
                            type="submit"
                            label={'Create Account'}
                            loadingLabel='Creating...'
                            loading={isSubmitting}
                            disabled={isSubmitting}
                            className={`w-full bg-blue-800 text-white font-medium py-2 px-4 rounded-lg ${isSubmitting ? 'opacity-50 cursor-not-allowed' : 'hover:bg-blue-900'}`}
                        />
                    </form>
                </div>
            </div>
        </div>
    );
};

export default CreateAccountModal;